export default {"src":"/blogs/_next/static/media/close-btn.e529e859.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};